// utils/request.js —— axios 统一封装
// 后端约定：
//   - 统一响应体含 code（200 成功 / 401 未登录 / 500 业务失败）
//   - SaResult 类接口（查词/音节/相似词/登录）把业务字段放在响应体「顶层」（如 res.wordInfo、res.NewSimilarity）
//   - Result<T> 类接口（课本/图片/视频）把业务数据放在 res.data
// 本封装在响应拦截器中直接返回后端 JSON 对象，方便两种格式统一用 res.xxx 读取
import axios from 'axios'
import { Message } from 'element-ui'

// 后端服务地址：
//   本地联调走 devServer 代理（vue.config.js 中 /api -> http://localhost:8086），
//   因此 baseURL 置空，请求保持同源 /api/xxx，由代理转发，避免跨域 CORS 拦截。
//   生产环境如需直连后端，再改为 http://8.137.88.30:8086
const BASE_URL = ''

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 20000
})

// 请求拦截器：注入 satoken（无状态鉴权，token 走请求头，不依赖 Cookie）
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('satoken') || ''
    config.headers['satoken'] = token
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器：统一处理登录态与业务错误
request.interceptors.response.use(
  (response) => {
    const res = response.data
    // 后端返回非 JSON（如静态资源）时直接放行
    if (!res || typeof res.code === 'undefined') {
      return res
    }
    // 登录失效
    if (res.code === 401) {
      Message.error('登录已失效，请重新登录')
      localStorage.removeItem('satoken')
      if (window.location.hash !== '#/login') {
        window.location.hash = '#/login'
      }
      return Promise.reject(res)
    }
    // 业务失败
    if (res.code !== 200) {
      Message.error(res.msg || '请求失败')
      return Promise.reject(res)
    }
    // 成功：返回完整响应体（含顶层业务字段）
    return res
  },
  (error) => {
    Message.error('网络请求失败，请检查网络或稍后重试')
    return Promise.reject(error)
  }
)

export default request
export { BASE_URL }
